import { addToast } from "./addToast";

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
  addToast("success", "Copied to clipboard!");
};
